export default __webpack_public_path__ + "static/media/landscape0.116ef932.jpeg";